// Staff chat query keys. Every key is scoped by `${organizationId}|${userId}`: the QueryClient outlives a logout, so a
// cached thread (PHI-adjacent) must never show to the next person signed in on this browser.
export const STAFF_CHAT_ROOT = 'staff-chat' as const;

export function staffChatKeys(who: string) {
  return {
    all: () => [STAFF_CHAT_ROOT, who] as const,
    directory: () => [STAFF_CHAT_ROOT, who, 'directory'] as const,
    threads: () => [STAFF_CHAT_ROOT, who, 'threads'] as const,
    thread: (id: string) => [STAFF_CHAT_ROOT, who, 'thread', id] as const,
    messages: (id: string) => [STAFF_CHAT_ROOT, who, 'messages', id] as const,
    unread: () => [STAFF_CHAT_ROOT, who, 'unread'] as const,
  };
}
